import {Page} from '../../Models';
import {DevelopmentTicket} from '../../Services/TicketService';

export const SET_DEV_TICKETS = 'tickets/SET_DEV_TICKETS';
export const SET_DEV_PAGE = 'tickets/SET_DEV_PAGE';
export const SET_DEV_VERSION = 'tickets/SET_DEV_VERSION';
export const SET_DEV_FILTER = 'tickets/SET_DEV_FILTER';
export const SET_DEV_HASH = 'tickets/SET_DEV_HASH';
export const SET_VERSIONS = 'tickets/SET_VERSIONS';
export const SET_LOADING = 'tickets/SET_LOADING';

interface SetDevelopmentTicketsAction {
  type: typeof SET_DEV_TICKETS;
  payload: Page<DevelopmentTicket>;
}

interface SetDevelopmentPageAction {
  type: typeof SET_DEV_PAGE;
  payload: number;
}

interface SetDevelopmentVersionAction {
  type: typeof SET_DEV_VERSION;
  payload: string;
}

interface SetDevelopmentFilterAction {
  type: typeof SET_DEV_FILTER;
  payload: DevelopmentFilter;
}

interface SetDevelopmentHashAction {
  type: typeof SET_DEV_HASH;
  payload: string;
}

interface SetVersionsAction {
  type: typeof SET_VERSIONS;
  payload: string[];
}

interface SetLoadingAction {
  type: typeof SET_LOADING;
  payload: boolean;
}

export interface TicketsState {
  development: {
    currentFilter: DevelopmentFilter;
    currentPage: number;
    currentVersion: string;

    requestHash: string;

    list: Page<DevelopmentTicket>;
    versions: string[];
  };
  loading: boolean;
}

export type TicketsActionTypes =
  SetDevelopmentTicketsAction |
  SetDevelopmentPageAction |
  SetDevelopmentVersionAction |
  SetDevelopmentFilterAction |
  SetDevelopmentHashAction |
  SetVersionsAction |
  SetLoadingAction;

export type DevelopmentFilter = 'All' | 'Tailored' | 'Unreleased' | 'Version' | 'Module' | 'Reporter' | 'Organisation';
